import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Menu } from '../../../components/ui/menu';
import { AlertBox } from '../../../components/ui/alertBox';
import { useMembershipAccess } from '../../../hooks/membership';
import { useCRM } from '../../../hooks/crm';

const FindInvestorsHeader = ({ allowWrap = false }) => {
  const { t } = useTranslation();
  const { canAccessBoards } = useMembershipAccess();
  const {
    boards,
    selectedBoard,
    selectBoard,
    loading,
  } = useCRM();

  const buttonLabel = loading
    ? 'Loading boards...'
    : boards.length === 0
      ? 'No boards'
      : selectedBoard?.board_name || 'Choose a board';

  const selectedText = boards.length === 0 || !selectedBoard
    ? t('app:crm.t49')
    : t('app:crm.t50', { boardName: selectedBoard.board_name });

  const menuTabs = [
    {
      label: buttonLabel,
      items: loading
        ? [{ label: 'Loading boards...', disabled: true }]
        : boards.length === 0
          ? [{ label: 'No boards', disabled: true }]
          : boards.map((board) => ({
            label: board.board_name,
            onClick: () => {
              if (!canAccessBoards) {
                return;
              }

              selectBoard(board.board_id);
            },
            disabled: !canAccessBoards,
          })),
    },
  ];

  return (
    <div
      className={`flex items-center ${allowWrap ? 'flex-wrap' : 'flex-nowrap'}`}
    >
      <div className="relative group">
        <Menu tabs={menuTabs} />
      </div>

      <div
        className={`ml-8 text-sm flex-shrink-0 ${
          allowWrap ? 'mt-2 w-full' : ''
        }`}
      >
        <AlertBox variant="yellow" size="xs">
          {selectedText}
        </AlertBox>
      </div>
    </div>
  );
};

FindInvestorsHeader.propTypes = {
  allowWrap: PropTypes.bool,
};

export default FindInvestorsHeader;
